import { render } from "./menu-item.html?vue&type=template&id=67b95734&scoped=true&ts=true"
import script from "./menu-item.ts?vue&type=script&lang=ts"
export * from "./menu-item.ts?vue&type=script&lang=ts"

import "./menu-item.scss?vue&type=style&index=0&id=67b95734&lang=scss&scoped=true"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b95734"]])

export default __exports__